export const loginReturnToKey = 'selfservice.loginReturnTo';

const landingPaths = [
  '/contact-listing', '/agency-contacts', '/terminate-agency-contacts',
  '/contact-types', '/general-details', '/agency-codes', '/primary-agency-code',
  '/user-privileges', '/agency-contact-profile', '/search-agency-contact',
  '/agency-administration', '/communication-preferences',
];

export function getLoginDestination(location: string): string | null {
  if (location.startsWith('//') || location.includes('\\')
    || (!location.startsWith('/') && !location.startsWith(`${window.location.origin}/`))) {
    return null;
  }
  const url = new URL(location, window.location.origin);
  if (url.origin !== window.location.origin
    || url.searchParams.has('code') || url.searchParams.has('state')
    || url.searchParams.has('error')) {
    return null;
  }

  const page = url.pathname === '/' ? url.searchParams.get('page') : null;
  const pathname = page ? `/${page}` : url.pathname;
  if (!landingPaths.includes(pathname)) {
    return null;
  }
  if (page) {
    url.searchParams.delete('page');
  }
  return `${pathname}${url.search}${url.hash}`;
}

export function rememberLoginDestination(location: string) {
  const destination = getLoginDestination(location);
  if (destination) {
    sessionStorage.setItem(loginReturnToKey, destination);
  } else {
    sessionStorage.removeItem(loginReturnToKey);
  }
}

export function getLoginLandingPage(location: string, isEmployee: boolean, isAdmin = false): string {
  const saved = sessionStorage.getItem(loginReturnToKey);
  const requested = getLoginDestination(saved || location);
  if (saved && !requested) {
    console.error('Invalid Self-Service login return destination');
  }
  const pathname = requested ? new URL(requested, window.location.origin).pathname : null;

  if (isEmployee) {
    return requested && ['/agency-administration', '/search-agency-contact'].includes(pathname || '')
      ? requested : '/agency-administration';
  }
  if (!isAdmin && ['/agency-contacts', '/contact-listing'].includes(pathname || '')) {
    return '/agency-contact-profile';
  }
  return requested || (isAdmin ? '/agency-contacts' : '/agency-contact-profile');
}
